var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",class:( _obj = {}, _obj[_vm.activeClass] = _vm.model.isActive, _obj[_vm.model.cssClass] = _vm.model.cssClass, _obj ),attrs:{"href":_vm.model.url || null}},'component',_vm.model.attributes,false),[_vm._v(" "+_vm._s(_vm.model.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }